const round = (value, precession = 1) => {
  const precessionFactor = Math.pow(10, precession);
  return Math.round(value * precessionFactor) / precessionFactor;
};

export default round;
